/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { parametersFilter } from '../models/parametersFilter';
import type { parametersFilterCount } from '../models/parametersFilterCount';
import type { parametersFilterDelete } from '../models/parametersFilterDelete';
import type { responsesPartMeta } from '../models/responsesPartMeta';
import type { sso } from '../models/sso';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class SsoService {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * count sso
   * Count sso (with filtering, pagination and limiting). You can use filters in the query parameters (properly URL encoded) to restrict the search results:
   * - To restrict the search to specific values for a given field name, you can use the following syntax: filter[where][fieldName][eq]=value. Note that you can also nest the filter object to filter on multiple fields, like so: filter[where][and][0][fieldName1][eq]=value1&filter[where][and][1][fieldName2][eq]=value2. You can also use operators like gt, gte, lt, lte, ne, in, nin, etc.
   * - To limit the number of results returned by the query, use the following syntax: filter[limit]=25&filter[skip]=25
   * @param filter
   * @returns any Count of sso documents found. Wrapped in a JsonAPI root response with wrapped count result as data.
   * @throws ApiError
   */
  public getApiServicesecuritySsoCount(
    filter?: parametersFilterCount,
  ): CancelablePromise<{
    data?: {
      count?: number;
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/servicesecurity/sso/count',
      query: {
        'filter': filter,
      },
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * find one sso
   * Find one sso by its unique identifier.
   * @param identifier sso unique identifier
   * @returns any One sso document found. Wrapped in a JsonAPI root response with document as data.
   * @throws ApiError
   */
  public getApiServicesecuritySso(
    identifier: string,
  ): CancelablePromise<{
    data?: sso;
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/servicesecurity/sso/{identifier}',
      path: {
        'identifier': identifier,
      },
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * partially update one existing sso
   * Partially update one existing sso
   * @param identifier sso unique identifier
   * @param requestBody
   * @returns any updated sso. Wrapped in a JsonAPI root response.
   * @throws ApiError
   */
  public patchApiServicesecuritySso(
    identifier: string,
    requestBody?: sso,
  ): CancelablePromise<{
    data?: sso;
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/api/servicesecurity/sso/{identifier}',
      path: {
        'identifier': identifier,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * delete one sso
   * Delete one sso
   * @param identifier sso unique identifier
   * @returns any delete status sso. Wrapped in a JsonAPI root response.
   * @throws ApiError
   */
  public deleteApiServicesecuritySso(
    identifier: string,
  ): CancelablePromise<{
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/api/servicesecurity/sso/{identifier}',
      path: {
        'identifier': identifier,
      },
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * find many sso
   * Find many sso (with filtering, projection, pagination and limiting). You can use filters in the query parameters (properly URL encoded) to restrict the search results:
   * - To restrict the search to specific values for a given field name, you can use the following syntax: filter[where][fieldName][eq]=value. Note that you can also nest the filter object to filter on multiple fields, like so: filter[where][and][0][fieldName1][eq]=value1&filter[where][and][1][fieldName2][eq]=value2. You can also use operators like gt, gte, lt, lte, ne, in, nin, etc.
   * - To limit the number of results returned by the query, use the following syntax: filter[limit]=25&filter[skip]=25
   * - To only return specific fields, use the projection query parameter. Usage is as follows: filter[fields][fieldName1]=true&filter[fields][fieldName2]=true.
   * @param filter
   * @returns any One or many sso documents found. Wrapped in a JsonAPI root response with collection of documents as data.
   * @throws ApiError
   */
  public getApiServicesecuritySso1(
    filter?: parametersFilter,
  ): CancelablePromise<{
    data?: Array<sso>;
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/servicesecurity/sso',
      query: {
        'filter': filter,
      },
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * create one or multiple sso
   * Create one or multiple sso
   * @param requestBody
   * @returns any One or many sso documents created. Wrapped in a JsonAPI root response.
   * @throws ApiError
   */
  public postApiServicesecuritySso(
    requestBody?: (sso | Array<sso>),
  ): CancelablePromise<{
    data?: (sso | Array<sso>);
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/servicesecurity/sso',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * partially update many existing sso
   * Partially update many existing sso
   * @param requestBody
   * @returns any sso updated. Wrapped in a JsonAPI root response.
   * @throws ApiError
   */
  public patchApiServicesecuritySso1(
    requestBody?: Array<sso>,
  ): CancelablePromise<{
    data?: Array<sso>;
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/api/servicesecurity/sso',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * delete many sso
   * Delete many sso using filtering. You can use filters in the query parameters (properly URL encoded) to restrict the search results:
   * - To restrict the search to specific values for a given field name, you can use the following syntax: filter[where][fieldName][eq]=value. Note that you can also nest the filter object to filter on multiple fields, like so: filter[where][and][0][fieldName1][eq]=value1&filter[where][and][1][fieldName2][eq]=value2. You can also use operators like gt, gte, lt, lte, ne, in, nin, etc.
   * - To limit the number of results returned by the query, use the following syntax: filter[limit]=25&filter[skip]=25
   * @param filter
   * @returns any delete status sso. Wrapped in a JsonAPI root response.
   * @throws ApiError
   */
  public deleteApiServicesecuritySso1(
    filter?: parametersFilterDelete,
  ): CancelablePromise<{
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/api/servicesecurity/sso',
      query: {
        'filter': filter,
      },
      errors: {
        500: `default error response`,
      },
    });
  }

}
